module.exports = __webpack_public_path__ + "static/Smiths_pin-b71acc296736c85a26e17e79ec307f26.png";